function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

import { renderCompat as t, getDefaultSlot as e } from "../util/vue-compat/index-vue2.js";
import { warn as i } from "../util/warn.js";
import n from "instantsearch.js/es/index.js";
import { createInstantSearchComponent as a } from "../util/createInstantSearchComponent.js";
var r = "Vue InstantSearch: You used the prop api-key or app-id.\nThese have been replaced by search-client.\n\nSee more info here: https://www.algolia.com/doc/api-reference/widgets/instantsearch/vue/#widget-param-search-client";
export default a({
  name: "AisInstantSearch",
  props: {
    searchClient: {
      type: Object,
      required: !0
    },
    insightsClient: {
      type: Function,
      default: void 0
    },
    indexName: {
      type: String,
      required: !0
    },
    routing: {
      default: void 0,
      validator: function validator(t) {
        return !("boolean" == typeof t || !t.router && !t.stateMapping) || (i("The `routing` option expects an object with `router` and/or `stateMapping`.\n\nSee https://www.algolia.com/doc/api-reference/widgets/instantsearch/vue/#widget-param-routing"), !1);
      }
    },
    insights: {
      default: void 0,
      validator: function validator(t) {
        return void 0 === t || "boolean" == typeof t || "object" == _typeof(t);
      }
    },
    stalledSearchDelay: {
      type: Number,
      default: void 0
    },
    searchFunction: {
      type: Function,
      default: void 0
    },
    onStateChange: {
      type: Function,
      default: void 0
    },
    initialUiState: {
      type: Object,
      default: void 0
    },
    apiKey: {
      type: String,
      default: void 0,
      validator: function validator(t) {
        return t && i(r), !1;
      }
    },
    appId: {
      type: String,
      default: void 0,
      validator: function validator(t) {
        return t && i(r), !1;
      }
    },
    middlewares: {
      type: Array,
      default: null
    },
    future: {
      type: Object,
      default: void 0
    }
  },
  data: function data() {
    return {
      instantSearchInstance: n({
        searchClient: this.searchClient,
        insightsClient: this.insightsClient,
        insights: this.insights,
        indexName: this.indexName,
        routing: this.routing,
        stalledSearchDelay: this.stalledSearchDelay,
        searchFunction: this.searchFunction,
        onStateChange: this.onStateChange,
        initialUiState: this.initialUiState,
        future: this.future
      })
    };
  },
  render: t(function (t) {
    var i;
    return t("div", {
      class: (i = {}, i[this.suit()] = !0, i[this.suit("", "ssr")] = !1, i)
    }, e(this));
  })
});